import { garmentActions } from '../../actions/garment/garmentActions.js';

const INITIAL_STATE = {
    isFetching: false,
    isFetchingAll: false,
    isFetchingAttributes: false,
    isFetchingSceneGarments: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    error: null,
    garment: null,
    garments: [],
    garmentsByActor: [],
    sceneGarments: [],
    attributes: {
        categories: [],
        styles: [],
        patterns: [],
        textures: [],
        materials: []
    }
};

const GARMENT_REQUEST = "GARMENT_REQUEST";
const GARMENT_SUCCESS = "GARMENT_SUCCESS";
const GARMENT_FAILURE = "GARMENT_FAILURE";

const GET_GARMENTS_REQUEST = "GET_GARMENTS_REQUEST";
const GET_GARMENTS_SUCCESS = "GET_GARMENTS_SUCCESS";
const GET_GARMENTS_FAILURE = "GET_GARMENTS_FAILURE";

const GET_GARMENT_BY_ACTOR_REQUEST = "GET_GARMENT_BY_ACTOR_REQUEST";
const GET_GARMENT_BY_ACTOR_SUCCESS = "GET_GARMENT_BY_ACTOR_SUCCESS";
const GET_GARMENT_BY_ACTOR_FAILURE = "GET_GARMENT_BY_ACTOR_FAILURE";

const CREATE_GARMENT_REQUEST = "CREATE_GARMENT_REQUEST";
const CREATE_GARMENT_SUCCESS = "CREATE_GARMENT_SUCCESS";
const CREATE_GARMENT_FAILURE = "CREATE_GARMENT_FAILURE";

const UPDATE_GARMENT_REQUEST = "UPDATE_GARMENT_REQUEST";
const UPDATE_GARMENT_SUCCESS = "UPDATE_GARMENT_SUCCESS";
const UPDATE_GARMENT_FAILURE = "UPDATE_GARMENT_FAILURE";

const DELETE_GARMENT_REQUEST = "DELETE_GARMENT_REQUEST";
const DELETE_GARMENT_SUCCESS = "DELETE_GARMENT_SUCCESS";
const DELETE_GARMENT_FAILURE = "DELETE_GARMENT_FAILURE";

const GET_GARMENT_ATTRIBUTES_REQUEST = "GET_GARMENT_ATTRIBUTES_REQUEST";
const GET_GARMENT_ATTRIBUTES_SUCCESS = "GET_GARMENT_ATTRIBUTES_SUCCESS";
const GET_GARMENT_ATTRIBUTES_FAILURE = "GET_GARMENT_ATTRIBUTES_FAILURE";

const GET_SCENE_GARMENTS_REQUEST = "GET_SCENE_GARMENTS_REQUEST";
const GET_SCENE_GARMENTS_SUCCESS = "GET_SCENE_GARMENTS_SUCCESS";
const GET_SCENE_GARMENTS_FAILURE = "GET_SCENE_GARMENTS_FAILURE";

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // Single Garment Operations
        case GARMENT_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null
            };
        case GARMENT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                garment: action.garment,
                error: null
            };
        case GARMENT_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };

        // Get All Garments
        case GET_GARMENTS_REQUEST:
            return {
                ...state,
                isFetchingAll: true,
                error: null
            };
        case GET_GARMENTS_SUCCESS:
            return {
                ...state,
                isFetchingAll: false,
                garments: action.garments,
                error: null
            };
        case GET_GARMENTS_FAILURE:
            return {
                ...state,
                isFetchingAll: false,
                error: action.error
            };

        // Get Garments by Actor
        case GET_GARMENT_BY_ACTOR_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null
            };
        case GET_GARMENT_BY_ACTOR_SUCCESS:
            return {
                ...state,
                isFetching: false,
                garmentsByActor: action.garments,
                error: null
            };
        case GET_GARMENT_BY_ACTOR_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };

        // Create Garment
        case CREATE_GARMENT_REQUEST:
            return {
                ...state,
                isCreating: true,
                error: null
            };
        case CREATE_GARMENT_SUCCESS:
            return {
                ...state,
                isCreating: false,
                garments: [...state.garments, action.garment],
                garmentsByActor: [...state.garmentsByActor, action.garment],
                error: null
            };
        case CREATE_GARMENT_FAILURE:
            return {
                ...state,
                isCreating: false,
                error: action.error
            };

        // Update Garment
        case UPDATE_GARMENT_REQUEST:
            return {
                ...state,
                isUpdating: true,
                error: null
            };
        case UPDATE_GARMENT_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                garment: action.garment,
                garments: state.garments.map(g => g.id === action.garment.id ? action.garment : g),
                garmentsByActor: state.garmentsByActor.map(g => g.id === action.garment.id ? action.garment : g),
                error: null
            };
        case UPDATE_GARMENT_FAILURE:
            return {
                ...state,
                isUpdating: false,
                error: action.error
            };

        // Delete Garment
        case DELETE_GARMENT_REQUEST:
            return {
                ...state,
                isDeleting: true,
                error: null
            };
        case DELETE_GARMENT_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                garments: state.garments.filter(g => g.id !== action.garmentId),
                garmentsByActor: state.garmentsByActor.filter(g => g.id !== action.garmentId),
                error: null
            };
        case DELETE_GARMENT_FAILURE:
            return {
                ...state,
                isDeleting: false,
                error: action.error
            };

        // Get Garment Attributes
        case GET_GARMENT_ATTRIBUTES_REQUEST:
            return {
                ...state,
                isFetchingAttributes: true,
                error: null
            };
        case GET_GARMENT_ATTRIBUTES_SUCCESS:
            return {
                ...state,
                isFetchingAttributes: false,
                attributes: action.attributes,
                error: null
            };
        case GET_GARMENT_ATTRIBUTES_FAILURE:
            return {
                ...state,
                isFetchingAttributes: false,
                error: action.error
            };

        // Get Scene Garments
        case GET_SCENE_GARMENTS_REQUEST:
            return {
                ...state,
                isFetchingSceneGarments: true,
                error: null
            };
        case GET_SCENE_GARMENTS_SUCCESS:
            return {
                ...state,
                isFetchingSceneGarments: false,
                sceneGarments: action.garments,
                error: null
            };
        case GET_SCENE_GARMENTS_FAILURE:
            return {
                ...state,
                isFetchingSceneGarments: false,
                error: action.error
            };

        default:
            return state;
    }
};
